export interface CsvColumn<T> {
  header: string;
  value: (row: T) => string | number;
}

const escapeCell = (value: string | number | null | undefined): string => {
  const str = value === null || value === undefined ? "" : String(value);
  // Quote cells containing commas, quotes, or newlines so columns stay intact.
  if (/[",\n\r]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
};

/**
 * Build a CSV from the given rows and trigger a browser download.
 * A UTF-8 BOM is prepended so Excel opens the file with the correct encoding.
 */
export const downloadCsv = <T>(
  filename: string,
  columns: CsvColumn<T>[],
  rows: T[]
): void => {
  const headerLine = columns.map((c) => escapeCell(c.header)).join(",");
  const dataLines = rows.map((row) =>
    columns.map((c) => escapeCell(c.value(row))).join(",")
  );
  const csv = [headerLine, ...dataLines].join("\r\n");

  const utf8Bom = "﻿";
  const blob = new Blob([utf8Bom + csv], {
    type: "text/csv;charset=utf-8;",
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
